import { useTranslation } from "react-i18next";

type IProps = {
  keyTxt?: string;
  sub?: string;
};

export default function NoInf({ keyTxt = "row_ttl_add_inf", sub }: IProps) {
  const { t } = useTranslation();
  return (
    <div className="w-full text-center py-4 text-red-500 font-bold">
      <h4>등록된 {t(keyTxt)}가 없습니다.</h4>
      <h4>{sub}</h4>
    </div>
  );
}
